import { Box, Container, Grid, Typography, Stack, IconButton, Link } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

import logo from "../assets/img/smartTrialWhite.svg";
import zigzag from "../assets/img/zigzag.png";
import dotted from "../assets/img/dotted-img.png";

export default function LoginFooter() {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        bgcolor: "#C09C9D",
        color: "#fff",
        py: { xs: 4, md: 6 },
        flexShrink: 0, // ensures the footer doesn't shrink on tiny screens
        overflow: "hidden",
      }}
    >
      {/* Decorative background images */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <Box
          component="img"
          src={zigzag}
          alt=""
          sx={{
            position: "absolute",
            top: -20,
            left: -20,
            opacity: 0.15,
            maxWidth: "60%",
          }}
        />
        <Box
          component="img"
          src={dotted}
          alt=""
          sx={{
            position: "absolute",
            bottom: -30,
            right: -30,
            opacity: 0.15,
            maxWidth: "60%",
          }}
        />
      </Box>

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box component="img" src={logo} alt="SmartTrial" sx={{ height: 70 }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack spacing={0.5}>
              <Typography
                href="https://appiell.ai/privacy-policy/"
                underline="hover"
                variant="body2"
                component="a"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                PRIVACY POLICY
              </Typography>
              <Typography
                href="https://appiell.ai/terms-conditions/"
                underline="hover"
                variant="body2"
                component="a"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                TERMS & CONDITIONS
              </Typography>
              <Typography
                href="mailto:support@appiell.ai"
                underline="hover"
                variant="body2"
                component="a"
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                Contact Appiell: support@appiell.ai
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack spacing={0.5}>
              <Typography variant="body2">APPIELL INC</Typography>
              <Typography variant="body2">SAN FRANCISCO. IRVINE. PLANO</Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={1}>
              <IconButton color="inherit" aria-label="Facebook" href="#" size="large">
                <FacebookIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Instagram" href="#" size="large">
                <InstagramIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Twitter/X" href="#" size="large">
                <TwitterIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
